<div class="d-flex justify-content-between align-items-center mb-3 head">
    <h5 class="dynamic-preview-heading mb-0">
        {{data?.department? 'Departments' : 'Services'}}
    </h5>
    <img src="assets/images/cross-icon.svg" alt="cross-icon" class="cursor-pointer ml-auto"
        (click)="dialgoRef.close()" />
</div>
<mat-dialog-content class="dynamic-content">

    <ul class="dept-srv-table p-0 m-0 custom-scroll">
        <li class="top-sticky-header">
            {{data?.department? 'Department' : 'Services'}}
            <label>Transaction Count</label>
        </li>
        <li class="dept-srv-table__row d-flex" *ngFor="let item of data?.list?.data">
            <div class="dept-srv-table__col d-flex justify-content-between w-100" *ngIf="data?.department">
                <p class="mb-0">{{item?.deptname?item?.deptname:'N/A'}}</p>
                <p class="mb-0" >{{getINRFormat(item?.totaltxn)}}</p>
            </div>
            <div class="dept-srv-table__col d-flex justify-content-between w-100 "  *ngIf="!data?.department">
                <p class="mb-0"> {{item?.servicename?item?.servicename:'N/A'}} ({{item?.deptname?item?.deptname:'N/A'}})</p>
                <p class="mb-0" >{{getINRFormat(item?.totaltxn)}}</p>
            </div>
        </li>
    </ul>
</mat-dialog-content>